import { Form, Col, Row, Button } from "react-bootstrap";
import { useState } from "react";
import emailjs from "emailjs-com";
import loading from "../../assets/images/posventa/loading.svg";
import check from "../../assets/images/posventa/check.png";
import iconLabelCheck from "../../assets/images/posventa/iconLabelCheck.svg";
import './index.scss';

const FormularioEstructura = ({ categoriaSeleccionada }) => {


  const query = new URLSearchParams(window.location.search);
  const utm_source = query && query.get("utm_source");
  const utm_medium = query && query.get("utm_medium");
  const utm_campaing = query && query.get("utm_campaing");

  const [mostrarFondoActivo, setMostrarFondoActivo] = useState({
    marcaFiat: false,
    marcaJeep: false,
    marcaRam: false,
    sucursalJesusMaria: false,
    horarioManana: false,
    horarioTarde: false,
  });

  const handleChangeFondoActivado = (nombre) => {
    setMostrarFondoActivo({
      marcaFiat: false,
      marcaJeep: false,
      marcaRam: false,
      sucursalJesusMaria: false,
      horarioManana: false,
      horarioTarde: false,
      [nombre]: true,
    });
  }

  const [etapasForm, setEtapasForm] = useState({
    contador: 1,
    tituloEtapaForm: 'Solicitante del turno',
    etapa1: true,
    etapa2: false,
    etapa3: false,
    etapa4: false,
    etapa5: false,
    etapa6: false,
  });

  const handleEtapasForm = (contador,tituloEtapa, etapaHabilitar) => {
    setEtapasForm({
      contador: contador,
      tituloEtapaForm: tituloEtapa,
      [etapaHabilitar] : true,
    })
  }
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState(null);
  const [toSend, setToSend] = useState({
    nombre: "",
    email: "",
    telefono: "",
    marcaAuto: "",
    categoriaSeleccionada: categoriaSeleccionada,
    sucursalSeleccionada: '',
    horarioSeleccionado: '',
    modelo: '',
    patente: '',
    ano: '',
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaing: utm_campaing,
  });

  const handleChangeNewInpunts = (nombre,valor,clase) => {
    handleChangeFondoActivado(clase);
    setToSend({
      ...toSend,
      [nombre]: valor,
    });
  }

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      // console.log("no valido");
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      e.preventDefault();
      setStatus("cargando");
      
      emailjs
        .send("landingMontironi", 'posventa_turnos', toSend, "user_EIC1ELQk7I3NPaFMEDa64")
        .then((response) => {
          setStatus("ok");

          setTimeout(() => {
            setStatus(null);
            setValidated(false);
            handleEtapasForm(1,'Solicitante del turno', 'etapa1');
            setToSend({
              ...toSend,
                nombre: "",
                email: "",
                telefono: "",
                marcaAuto: "",
                categoriaSeleccionada: "",
                sucursalSeleccionada: '',
                horarioSeleccionado: '',
                modelo: '',
                patente: '',
                ano: '',
                utm_source: "",
                utm_medium: "",
                utm_campaing: "",
            });
          }, 4000);
        })
        .catch((err) => {
          setStatus("error");
          setTimeout(() => {
            setStatus(null);
          }, 4000);
        });
    }
  };

  return (
    <>
      <Form onSubmit={onSubmit} noValidate validated={validated} className="w-100 bg-form" id="formularioTop">
        {
          !status ? (
          <div className="contenedorSpanNumeros">
            <span> {etapasForm.contador} - 5 </span>
          </div>
          ) : null
        }

        {
          !status ? (
          <div className="contenedortituloFormularioh3">
            <h3 className="text-center">{etapasForm.tituloEtapaForm}</h3>
          </div>
          ) : null
        }
        
        
        {status === null && (
          <section className="contenidoTodasEtapas">
          {
            etapasForm.etapa1 && (
              <div className="etapa1">
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="nombre">
                      <Form.Label>Nombre y Apellido</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      value={toSend.nombre}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="nombre">
                      <Form.Label>Celular</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="telefono"
                      name="telefono"
                      value={toSend.telefono}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="nombre">
                      <Form.Label>Email</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="email"
                      name="email"
                      value={toSend.email}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <button className="btnSiguienteModal" onClick={() => handleEtapasForm(2,"Marca del Vehículo","etapa2")}>
                  Siguiente
                </button>
              </div>
            )
          }
          {
            etapasForm.etapa2 && (
              <div>
                <button type="button" className={ mostrarFondoActivo.marcaFiat ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("marcaAuto","FIAT","marcaFiat")}>
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>FIAT</span>
                </button>
                <button type="button" className={ mostrarFondoActivo.marcaJeep ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("marcaAuto","JEEP","marcaJeep")}>
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>JEEP</span>
                </button>
                <button type="button" className={ mostrarFondoActivo.marcaRam ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("marcaAuto","RAM","marcaRam")}>
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>RAM</span>
                </button>
                <button className="btnSiguienteModal" onClick={() => handleEtapasForm(3,"Sucursal a la que quiere asistir","etapa3")}>
                  Siguiente
                </button>
              </div>
            )
          }
          {
            etapasForm.etapa3 && (
              <div>
                <button type="button" className={ mostrarFondoActivo.sucursalJesusMaria ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("sucursalSeleccionada","JESÚS MARÍA (J Frias 547)","sucursalJesusMaria")}>
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>JESÚS MARÍA (J Frias 547)</span>
                </button>
                <button className="btnSiguienteModal" onClick={() => handleEtapasForm(4,"Datos del vehículo","etapa4")}>
                  Siguiente
                </button>
              </div>
            )
          }

          {
            etapasForm.etapa4 && (
              <div className="etapa1"v>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="modelo">
                      <Form.Label>Modelo</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="modelo"
                      name="modelo"
                      value={toSend.modelo}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="patente">
                      <Form.Label>Patente</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="patente"
                      name="patente"
                      value={toSend.patente}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="ano">
                      <Form.Label>Modelo / año</Form.Label>
                    </Form.Group >
                    <Form.Control
                      id="ano"
                      name="ano"
                      value={toSend.ano}
                      onChange={handleChange}
                      className="inputs-form-largo"
                      required
                    />
                  </Col>
                </Row>
                <button className="btnSiguienteModal" onClick={() => handleEtapasForm(5,"Horario de preferencia para su turno","etapa5")}>
                  Siguiente
                </button>
              </div>
            )
          }

          {
            etapasForm.etapa5 && (
              <div>
                <button type="button" className={ mostrarFondoActivo.horarioManana ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("horarioSeleccionado","Mañana (9 a 13:30hs)","horarioManana")}>
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>Mañana (9 a 13:30hs)</span>
                </button>
                <button type="button" className={ mostrarFondoActivo.horarioTarde ? 'active-fondo button-option' : 'button-option'} onClick={() => handleChangeNewInpunts("horarioSeleccionado","Tarde  (14:30 a 18hs)","horarioTarde")} >
                  <img src={iconLabelCheck} alt="icon check" />
                  <span>Tarde  (14:30 a 18hs)</span>
                </button>
                <button className="btnSiguienteModal" onClick={() => handleEtapasForm(6,"Usted va a sacar un turno para: ","etapa6")}>
                  Siguiente
                </button>
              </div>
            )
          }
          {
            etapasForm.etapa6 && (
              <div className="etapaConfirmacionDeDatos">
                <section>
                  <h3>Titular</h3>
                  <ul>
                    <li> {toSend.nombre} </li>
                    <li> {toSend.email} </li>
                    <li> {toSend.telefono} </li>
                  </ul>
                </section>
                <section>
                  <h3>Marca</h3>
                  <ul>
                    <li> {toSend.marcaAuto} </li>
                  </ul>
                </section>
                <section>
                  <h3>Sucursal</h3>
                  <ul>
                    <li> {toSend.sucursalSeleccionada} </li>
                  </ul>
                </section>
                <section>
                  <h3>Vehículo</h3>
                  <ul>
                    <li> Modelo: {toSend.modelo} </li>
                    <li> Patente: {toSend.patente} </li>
                    <li> Año: {toSend.ano} </li>
                  </ul>
                </section>
                <section>
                  <h3>Horario preferencial</h3>
                  <ul>
                    <li> {toSend.horarioSeleccionado} </li>
                  </ul>
                </section>
                
              <Row>
                <Col md={12}>
                  <Button type="submit" className="btnSiguienteModal">
                    Confirmar turno
                  </Button>
                </Col>
              </Row>
              </div>
            )
          }
    
          </section>
        )}

        {status === "cargando" && (
          <div className="msgHeader text-center h-100 d-flex justify-content-center align-content-center align-items-center contenedorMensajeEnviado">
            <img src={loading} alt="Cargando" style={{ marginTop: "50px", marginBottom: "50px" }} />
            <h5 className="estamosProcesandoSuSolicitud">Estamos <br/>
            procesando tu  <br/>
            consulta</h5>
          </div>
        )}

        {status === "ok" && (
          <div className="msgHeader text-center  h-100 d-flex justify-content-center align-content-center align-items-center">
            <div>
              <img src={check} alt="Enviado" className="img-fluid" style={{ marginBottom: "20px", maxWidth: "60px" }} />
              <p
                style={{
                  color: "#3AAA35",
                  fontWeight: "bold",
                  fontSize: "22px",
                  marginBottom: "0",
                  textAlign: "center",
                }}
              >
                ¡Listo!
              </p>
              <p style={{ color: "#B3B3B3", textAlign: "center" }}>Nos vamos a comunicar con vos 
a la brevedad.</p>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="msgHeader text-center h-100 d-flex justify-content-center align-content-center align-items-center">
            <div>
              <p
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "22px",
                  marginBottom: "0",
                  textAlign: "center",
                }}
              >
                Se ha producido un error
              </p>
              <p style={{ color: "B3B3B3", textAlign: "center" }}>Vuelva a intentarlo mas tarde</p>
            </div>
          </div>
        )}
      </Form>
    </>
  );
};

export default FormularioEstructura;
